import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const HomeworkAssignmentsFeature: FeatureMetadata = {
  id: "homeworkAssignments",
  moduleName: "academics",
  guardianNavigation: {
    order: 4,
  },

  navigation: {
    label: "Homework",
    path: "/homework",
    icon: ClipboardDocumentCheckIcon,
    order: 7,
  },

  route: {
    path: "/homework",
    element: lazy(() => import("./pages/HomeworkAssignmentsPage")),
  },

  permissions: {
    view: "Academics.HomeworkAssignments.view",
    create: "Academics.HomeworkAssignments.create",
    edit: "Academics.HomeworkAssignments.edit",
    delete: "Academics.HomeworkAssignments.edit",
    submitOnline: "Academics.HomeworkAssignments.submitOnline",
  },

  readiness: "live",
};
